import { Button, Text, notification } from "components/common";
import { useNavigate } from "react-router-dom";
import theme from "utils/themeVars";
import { UserAvatar } from "components/custom/userListRow";
import { getUserProfilePath } from "constants/app-paths";
import {
  useGetFollowRequestsQuery,
  useAcceptFollowRequestMutation,
  useRejectFollowRequestMutation,
} from "features/community/apis";

const FollowRequests = ({ compact = false }) => {
  const navigate = useNavigate();
  const { data, isLoading } = useGetFollowRequestsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const [accept, { isLoading: accepting }] = useAcceptFollowRequestMutation();
  const [reject, { isLoading: rejecting }] = useRejectFollowRequestMutation();

  const requests = data?.data || [];
  if (isLoading || requests.length === 0) return null;

  const handle = async (fn, code, label) => {
    const res = await fn(code);
    if (res?.error) {
      notification.error({ message: res?.error?.message || "Action failed" });
    } else {
      notification.success({ message: label });
    }
  };

  return (
    <div
      style={{
        border: `1px solid ${theme["gray300"]}`,
        borderRadius: 8,
        padding: 16,
        marginBottom: compact ? 0 : 20,
        background: "#fff",
      }}
    >
      <Text style={{ fontWeight: 700, fontSize: 15 }}>
        Follow requests ({requests.length})
      </Text>
      <div style={{ marginTop: 8 }}>
        {requests.map((req) => (
          <div
            key={req.follow_id}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              padding: "10px 0",
              borderBottom: `1px solid ${theme["gray200"]}`,
            }}
          >
            <div
              style={{ cursor: "pointer" }}
              onClick={() => navigate(getUserProfilePath(req.requester?.user_code))}
            >
              <UserAvatar user={req.requester} size={40} />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <Text style={{ fontWeight: 600 }}>
                {req.requester?.name || "User"}
              </Text>
              {req.requester?.username && (
                <div>
                  <Text className="gray-800" style={{ fontSize: 12 }}>
                    @{req.requester.username}
                  </Text>
                </div>
              )}
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <Button
                size="small"
                type="primary"
                text="Accept"
                loading={accepting}
                onClick={() =>
                  handle(accept, req.requester?.user_code, "Request accepted")
                }
              />
              <Button
                size="small"
                type="default"
                text="Decline"
                loading={rejecting}
                onClick={() =>
                  handle(reject, req.requester?.user_code, "Request declined")
                }
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FollowRequests;
